import VirtualCardsAllCardsReducer, {
  Actions as VirtualCardsAllCardsActions,
  initialState as initialVirtualCardsAllCardsState,
  VirtualCardsAllCardsState,
} from 'src/app/VirtualCardsAllCards/redux/virtualCardsAllCards.reducer'
import VirtualCardsRequestsReducer, {
  Actions as VirtualCardsRequestsActions,
  initialState as initialVirtualCardsRequestsState,
  VirtualCardsRequestsState,
} from 'src/app/VirtualCardsNeedsApproval/redux/virtualCardsNeedsApproval.reducers'
import VirtualCardsYourCardsReducer, {
  Actions as VirtualCardsYourCardsActions,
  initialState as initialVirtualCardsYourCardsState,
  VirtualCardsYourCardsState,
} from 'src/app/VirtualCardsYourCards/redux/virtualCardsYourCards.reducer'

export type VirtualCardsState = {
  virtualCardsAllCards: VirtualCardsAllCardsState
  virtualCardsYourCards: VirtualCardsYourCardsState
  virtualCardsRequests: VirtualCardsRequestsState
}

export const initialState: VirtualCardsState = {
  virtualCardsAllCards: initialVirtualCardsAllCardsState,
  virtualCardsYourCards: initialVirtualCardsYourCardsState,
  virtualCardsRequests: initialVirtualCardsRequestsState,
}

export type Actions = VirtualCardsAllCardsActions | VirtualCardsYourCardsActions

const VirtualCardsReducer = (
  state = initialState,
  action: Actions,
): VirtualCardsState => ({
  virtualCardsAllCards: VirtualCardsAllCardsReducer(
    state.virtualCardsAllCards,
    action as VirtualCardsAllCardsActions,
  ),
  virtualCardsYourCards: VirtualCardsYourCardsReducer(
    state.virtualCardsYourCards,
    action as VirtualCardsYourCardsActions,
  ),
  virtualCardsRequests: VirtualCardsRequestsReducer(
    state.virtualCardsRequests,
    action as VirtualCardsRequestsActions,
  ),
})

export default VirtualCardsReducer
